import { Component, ComponentFactoryResolver, Injector, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppComponentBase } from '@shared/app-component-base';
import { CreatePosmProductionDemandDto, PosmProductionDemandServiceProxy, ProductDto, ProductServiceProxy } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { ProductPhotoComponent } from '../../common-components/product-photo/product-photo.component';
import { AutocompleteComboComponent } from '../../common-components/autocomplete-combo/autocomplete-combo.component';
import { ActivatedRoute, Router } from '@angular/router';

export class State{
  name: string;
  population: string ;
  flag:string ;
}

//**dsd */
@Component({
  selector: 'kt-demand-form',
  templateUrl: './demand-form.component.html',
  styleUrls: ['./demand-form.component.scss']
})
export class DemandFormComponent extends AppComponentBase implements OnInit {

  @ViewChild('templateProductImage', {read: ViewContainerRef, static: false}) productImageHolder: ViewContainerRef ;
  @ViewChild('combSupplier', {static: false}) combSupplier: AutocompleteComboComponent;

  products$ = new BehaviorSubject<ProductDto[]>(null);
  filteredProducts$ = new BehaviorSubject<ProductDto[]>(null);

  ctrlProductKeyword = new FormControl();

  filteredStates: Observable<any[]>;
  productKeyword : string ;
  selectedProduct$ = new BehaviorSubject<ProductDto>(null) ;
  lastDeliveryDate : any ;

  createParameter = new CreatePosmProductionDemandDto() ;


  recordId : number ;
  isUpdateMode : boolean = false ;
  pp : string = '';

  constructor(
    injector: Injector,
    private _productServiceProxy : ProductServiceProxy,
    private resolver : ComponentFactoryResolver,
    public posmProductionDemandProxy : PosmProductionDemandServiceProxy,
	  private _route: ActivatedRoute,
	private _router : Router
  ) {
    super(injector);

    if (this._route.snapshot.params["id"]){
      this.recordId = this._route.snapshot.params["id"] ;
      this.isUpdateMode = true ;
    }
    

   // alert(this.recordId);
    
  }

  async ngOnInit() {
    this.moduleHeader.setTitle("Yeni POSM Üretim Talebi");
    this.moduleHeader.setDesc("Yeni üretim talebi girisi yapabilirsiniz.");

    

    this.ctrlProductKeyword.valueChanges.pipe(
      debounceTime(500),
      switchMap(changedValue => this._productServiceProxy.getAll(changedValue, "", 0, 100)),
   ).subscribe(res => this.products$.next(res.items));

   
   

  
      if (this.isUpdateMode){
        
        //Update prosesi iptal edildi. HA: 22.10.2023
        //await this.loadDataForUpdate();
      }
      else{
        this._productServiceProxy.getAll("", "", 0, 20).subscribe(res => {
          this.products$.next(res.items);
        
        });
      }

  }

  async loadDataForUpdate(){
    this.posmProductionDemandProxy.get(this.recordId)
      .subscribe(res => {
        
        this.createParameter.amount = res.amount ;
        this.createParameter.comment ="";
        this.createParameter.estimatedProductionDate = res.estimatedProductionDate ;
        this.createParameter.productId = res.productId ;
        this.createParameter.supplierAddressId = res.supplierAddressId ;

        console.log("Server Data:", this.createParameter);

        this._productServiceProxy.get(res.productId).subscribe(async prod => {
          let prods : ProductDto[] = [] ;
          prods.push(prod);
          this.products$.next(prods);

          this.selectedProduct$.next(prod);

         

          this.displayFunc(prod);

          this.loadProductPhotoComponent(prod);

          this.pp = prod.name ;

          
        

        })
      });


    
  }


  displayFunc(product: ProductDto){
    return product.name ;
  }


  onProductSelected(prod: ProductDto){
    this.selectedProduct$.next(prod);

    this.loadProductPhotoComponent(prod);

    this.createParameter.productId = prod.id ;
  }

  loadProductPhotoComponent(prod: ProductDto){
      this.productImageHolder.clear();

      const factory = this.resolver.resolveComponentFactory(ProductPhotoComponent);

      let ref = this.productImageHolder.createComponent(factory);

      ref.instance.ProductCode = prod.kod ;
      ref.instance.ProductName = prod.name;
      ref.instance.Width = 80 ;
  }

  /**
   * Urun arama combosunu temizler
   */
  clearSelectedProduct(){
    this.selectedProduct$.next(null);
    this.createParameter.productId = null ;
    this.productImageHolder.clear();
    this.ctrlProductKeyword.setValue('');
  }

  onSelectedSupplier(){
    this.createParameter.supplierAddressId = this.combSupplier.selectedOption ? parseInt(this.combSupplier.selectedOption.value) : null;
  }


  createNew(){
   console.log("Gonderilecek Parametre", this.createParameter);

  
    this.posmProductionDemandProxy.create(this.createParameter)
      .subscribe(res => {
		  console.log("Kayit islemi tamamlandi!");

		  this._router.navigate(['../list'], { relativeTo: this._route });
      });
    
  }
}
